import React, { useState, useEffect } from 'react';

const Footer = () => {
  const [isRecaptchaModalOpen, setIsRecaptchaModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('Thank You! You have been successfully registered.');

  
  useEffect(() => {
    // Load reCAPTCHA script if not already loaded
    if (!window.grecaptcha) {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    // Define the global reCAPTCHA load function
    window.onRecaptchaLoad = () => {
    };

    return () => {
      // Cleanup if needed
      if (window.onRecaptchaLoad) {
        delete window.onRecaptchaLoad;
      }
    };
  }, []);

  // Email validation function
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };


  
    
    
  // Handle subscribe function
  
  return (
    <>
      {/* Simple Professional Footer */}
      <footer className="bg-[#0c1526] text-white">
       
        

        <div className="container mx-auto px-4 py-6 overflow-hidden">
          
          {/* Simple links row - UPDATED CONTACT LINK */}
          <div className="text-center mb-4">
            <div className="flex flex-wrap justify-center gap-4">
              <a href="/contact" className="text-white hover:text-[#ff7e00] text-xs font-medium">Contact</a>
              <span className="text-gray-600">|</span>
              <a href="/terms-and-conditions.html" className="text-gray-300 hover:text-[#ff7e00] text-xs">Terms</a>
              <a href="/privacy-policy.html" className="text-gray-300 hover:text-[#ff7e00] text-xs">Privacy</a>
              <a href="/refund-policy.html" className="text-gray-300 hover:text-[#ff7e00] text-xs">Refund</a>
              <a href="/shipping-policy.html" className="text-gray-300 hover:text-[#ff7e00] text-xs">Shipping</a>
            </div>
          </div>

          {/* Social media icons */}
          <div className="text-center mb-4">
            <div className="flex justify-center gap-4">
              <a href="https://x.com/megaimpacts" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#ff7e00] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/marketfit-mega-impacts/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#ff7e00] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a href="https://www.youtube.com/@MegaImpacts" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#ff7e00] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>
          
          {/* Minimal copyright */}
          <div className="text-center text-xs text-gray-400">
            <p>&copy; 2025 Mega Impacts</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;